import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

export function LinkToThisText({ text, testid }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); setDone(true); setTimeout(() => setDone(false), 2000); }
    catch { setDone(false); }
  };
  return (
    <button onClick={copy} className="px-3 py-1.5 rounded-sm text-white inline-flex items-center gap-1.5 text-xs font-semibold shrink-0" style={{ background: "#7A1F2B" }} data-testid={testid}>
      {done ? <Check size={13}/> : <Copy size={13}/>} {done ? "Copied" : "Copy"}
    </button>
  );
}
